module.exports = __webpack_public_path__ + "static/media/relevanseek.1351a07e.png";